<template>
  <div>
    <img class="mobile-hide" src='../assets/header.jpg'/>
    <img class="mobile-show" src='../assets/header_phones.jpg'/>
  </div>
</template>

<script>
export default {
  name: "PianoHeader"
}
</script>

<style scoped>

img {
  /*width: 100%;*/
  max-width: 100%;
  height: 200px;
}

/* Phones */
@media only screen
and (max-device-width: 667px)
and (orientation: portrait) {

  img {
    width: 100%;
    height: 100%;
  }
}
</style>